import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import Sheet from 'components/utils/Sheet'
import FlashHotelRateOption from 'components/OfferPage/FlashHotel/SameRoom/FlashHotelRateOption'
import { getBasePackageUniqueKey } from 'lib/offer/offerUtils'

interface Props {
  packageViews: Array<App.OfferPackageOptionView>
}

function FlashHotelPackageOptionsModalTab(props: Props) {
  const { packageViews } = props
  const intl = useIntl()

  const availablePackagesText = intl.formatMessage(
    {
      id: 'bkbbhVqu1OAc0_Dd3vET',
      defaultMessage: '{count, plural, one {# package option} other {# package options}} available',
      description: 'Text showing number of package options available on the offer detail page',
    },
    {
      count: packageViews.length,
    },
  )

  return (
    <Pane background="light-background">
      {packageViews.length > 1 && (
        <Pane background="normal-background" padding="12 20">
          <BodyText variant="small" colour="light-foreground-alt">
            {availablePackagesText}
          </BodyText>
        </Pane>
      )}
      <Group direction="vertical" gap={8}>
        {packageViews.map((view, index) => (
          <Sheet key={getBasePackageUniqueKey(view.package)} border="light-foreground">
            <FlashHotelRateOption
              packageView={view}
              packagePosition={packageViews.length > 1 ? index + 1 : undefined}
            />
          </Sheet>
        ))}
      </Group>
    </Pane>
  )
}

export default FlashHotelPackageOptionsModalTab
